import { inject, Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { DateRange, MatDateRangeSelectionStrategy } from '@angular/material/datepicker';

@Injectable()
export class CustomRangeSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
  private readonly _dateAdapter = inject<DateAdapter<D>>(DateAdapter<D>);
  private readonly _days: number;

  constructor(days: number) {
    this._days = days;
  }

  selectionFinished(date: D | null): DateRange<D> {
    return this._createCustomRange(date);
  }

  createPreview(activeDate: D | null): DateRange<D> {
    return this._createCustomRange(activeDate);
  }

  private _createCustomRange(date: D | null): DateRange<D> {
    if (date) {
      const start = this._dateAdapter.addCalendarDays(date, -Math.floor(this._days / 2));
      const end = this._dateAdapter.addCalendarDays(date, Math.ceil(this._days / 2) - 1);
      return new DateRange<D>(start, end);
    }

    return new DateRange<D>(null, null);
  }
}
